import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";

export default function PaymentCancel() {
  const { t } = useI18n();
  return (
    <main className="max-w-[720px] mx-auto px-6 md:px-12 py-28 text-center fade-in" data-testid="payment-cancel">
      <div className="label-caps text-muted-foreground mb-4">—</div>
      <h1 className="font-hand text-5xl md:text-6xl mb-6">{t("payment.cancel_title")}</h1>
      <p className="text-muted-foreground mb-10 max-w-md mx-auto">{t("payment.cancel_body")}</p>
      <Link to="/cart" className="btn-outline">{t("cart.title")}</Link>
    </main>
  );
}
